import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getOneMedia, updateMedia } from 'slice/mediaSlice';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const Update = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // const { loading, data } = useSelector((state) => state.media || {});
  const { loading, single: data } = useSelector((state) => state.media || {});

  const [formData, setFormData] = useState({
    title: '',
    url: ''
  });

  useEffect(() => {
    dispatch(getOneMedia(id));
  }, [dispatch, id]);

  useEffect(() => {
    if (data && Object.keys(data).length > 0) {
      setFormData({
        title: data.title || '',
        url: data.url || ''
      });
    }
  }, [data]);

  const handleChange = (e) => {
    const { name, value } = e.target; // ❗ FIXED destructuring
    setFormData((prevState) => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    try {
      dispatch(updateMedia({ id, data: formData }));
      toast.success('Media updated successfully!');
      navigate('/media');
    } catch (error) {
      console.error('There was a problem updating the media:', error.message);
    }
  };

  return (
    <>
      {/* 🔥 SAME UI WRAPPER AS BEFORE */}
      <div className="container card my-5">
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-sm-4 mt-2">
              <label htmlFor="title">Title</label>
              <input type="text" id="title" name="title" className="form-control" value={formData.title} onChange={handleChange} required />
            </div>

            <div className="col-sm-4 mt-2">
              <label htmlFor="url">Video URL</label>
              <input type="text" id="url" name="url" className="form-control" value={formData.url} onChange={handleChange} required />
            </div>
          </div>

          <div className="mt-3 text-right">
            <button className="btn btn-success" disabled={loading}>
              Update Media
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default Update;
